import { Icon, IconType } from "../../../common/icons/Icon";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";
import { aiAssistantTexts } from "../models/aiAssistantModels";
import { AiUsageMeter } from "./AiUsageMeter";
import styles from "../AiAssistantPage.module.scss";

interface IAiAssistantHeaderProps {
  isDesktopOrTablet: boolean;
  usedPercent: number;
  usedPercentLabel: string;
  resetDateLabel: string;
  hasUnreadTeamReplies: boolean;
  onOpenConversations: () => void;
  onNewConversation: () => void;
  onOpenTeamRequests: () => void;
}

export const AiAssistantHeader = ({
  isDesktopOrTablet,
  usedPercent,
  usedPercentLabel,
  resetDateLabel,
  hasUnreadTeamReplies,
  onOpenConversations,
  onNewConversation,
  onOpenTeamRequests,
}: IAiAssistantHeaderProps) => {
  const teamRequestsLabel = hasUnreadTeamReplies
    ? `${aiAssistantTexts.teamRequests} (има нов отговор)`
    : aiAssistantTexts.teamRequests;

  return (
    <header className={styles.header}>
      <div className={styles.header_left}>
        <RenderWhen condition={!isDesktopOrTablet}>
          <button
            type="button"
            className={styles.header_icon_btn}
            onClick={onOpenConversations}
            aria-label={aiAssistantTexts.openConversations}
          >
            <Icon type={IconType.ClockIcon} width="18px" height="18px" color="currentColor" />
          </button>
        </RenderWhen>

        <div className={styles.header_titles}>
          <h2 className={styles.header_title}>
            <Icon className={styles.header_title_icon} type={IconType.Sparkle} width="18px" height="18px" color="currentColor" />
            {aiAssistantTexts.title}
            <span className={styles.header_beta}>{aiAssistantTexts.betaTag}</span>
          </h2>
          <AiUsageMeter percent={usedPercent} label={usedPercentLabel} resetDateLabel={resetDateLabel} />
        </div>
      </div>

      <div className={styles.header_actions}>
        <button
          type="button"
          className={styles.header_btn}
          onClick={onOpenTeamRequests}
          aria-label={teamRequestsLabel}
          title={aiAssistantTexts.teamRequests}
        >
          <span className={styles.header_btn_icon}>
            <Icon type={IconType.ChatBubbles} width="17px" height="17px" color="currentColor" />
            <RenderWhen condition={hasUnreadTeamReplies}>
              <span className={styles.header_unread_dot} />
            </RenderWhen>
          </span>
          <span className={styles.header_btn_label}>{aiAssistantTexts.teamRequests}</span>
        </button>

        <button
          type="button"
          className={styles.header_btn}
          onClick={onNewConversation}
          aria-label={aiAssistantTexts.newConversation}
          title={aiAssistantTexts.newConversation}
        >
          <span className={styles.header_btn_icon}>
            <Icon type={IconType.Plus2} width="16px" height="16px" color="currentColor" />
          </span>
          <span className={styles.header_btn_label}>{aiAssistantTexts.newConversation}</span>
        </button>
      </div>
    </header>
  );
};
